import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { GameSection, GameStructure, useSoundWatcher } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { liveBetsDataStore } from '../store/liveBetsDataStore';

import { WebGameMain } from '../game';
import { HeaderWr } from './header';
import FooterWr from './footer';
import { PayoutsAndResultsContainer } from './payoutsAndResultsContainer';
import gameTyepLogo from '../assets/images/loading/game-logo.png';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../enums/notificaions';
import useSoundsByName from '../hooks/useSoundsByName';
import { gameStore } from '../store/gameStore';
import { soundService } from '../services/SoundService';

export const WebGame = observer(() => {
  const { gameTypes } = gameStore;
  const { isSkipLobby, gameTypeId } = gameConfigStore;

  const activeRoom = useMemo(() => {
    soundService.muteAll();
    soundService.stopAll();
    return gameTypes?.find((game) => game.gameTypeId === gameTypeId);
  }, [gameTypes, gameTypeId]);

  const soundsByName = useSoundsByName();
  useSoundWatcher(activeRoom?.name, soundsByName);

  useEffect(() => {
    return () => {
      liveBetsDataStore.resetLiveBetsData([]);
    };
  }, []);

  return (
    <GameStructure hasLobby={isSkipLobby} hasGameTypeLoading lobbyLogoImageSrc={gameTyepLogo}>
      <HeaderWr />
      <GameSection
        haveNotification
        translationValues={{}}
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        AdditionalResponseCode={AdditionalResponseCode}
        AdditionalErrorMessages={AdditionalErrorMessages}
      >
        <PayoutsAndResultsContainer />
        <WebGameMain />
      </GameSection>
      <FooterWr />
    </GameStructure>
  );
});
